export { createDeepSeek, deepseek } from './deepseek-provider';
export type {
  DeepSeekProvider,
  DeepSeekProviderSettings,
} from './deepseek-provider';
export { VERSION } from './version';
export type { DeepSeekChatOptions } from './chat/deepseek-chat-options';
export type { DeepSeekErrorData } from './chat/deepseek-chat-api-types';
